export const getters = {
  GET_TAB_LIST: 'GET_TAB_LIST', //* 탭리스트 가져오기
  GET_VIEWS_KPI_PERFORM_LIST: 'GET_VIEWS_KPI_PERFORM_LIST', //* 실적리스트 영역 ON/OFF 설정
  GET_VIEWS_KPI_REASON_LIST: 'GET_VIEWS_KPI_REASON_LIST', //* 성공부진사유 리스트 영역 ON/OFF 설정
  GET_KPI_TARGET_MONTH_LIST: 'GET_KPI_TARGET_MONTH_LIST', //* 월목표실적 데이터 가져오기
  GET_SAVED_REASON_ID: 'GET_SAVED_REASON_ID', //*저장한 성공/부진사유 정보
  GET_SAVED_MEASURE_ID: 'GET_SAVED_MEASURE_ID', //*저장한 성공/부진사유 대책 정보
  GET_ENTIRE_WEEK: 'GET_ENTIRE_WEEK', //* 전체 주 목록 가져오기
  GET_WWSEQ_PARAM: 'GET_WWSEQ_PARAM', //* 주차 파마리터 전달
  //! 팝업 ON/OFF 설정
  GET_VIEWS_KPI_REG_PERFORM_POP: 'GET_VIEWS_KPI_REG_PERFORM_POP', //* 실적입력 팝업 ON/OFF 설정
  GET_VIEWS_KPI_PRJ_POP: 'GET_VIEWS_KPI_PRJ_POP', //* 연결과제 팝업 ON/OFF 설정
  GET_VIEWS_CHART_GROUP_POP: 'GET_VIEWS_CHART_GROUP_POP', //* 차트그룹 리스트팝업 ON/OFF 설정
  GET_VIEWS_SELECTED_CHART_GROUP_POP: 'GET_VIEWS_SELECTED_CHART_GROUP_POP', //* 선택된 차트그룹 팝업 ON/OFF 설정
  GET_VIEWS_ANALYSIS_POP: 'GET_VIEWS_ANALYSIS_POP', //* 분석 팝업 ON/OFF 설정
  GET_VIEWS_PREV_REASON_POP: 'GET_VIEWS_PREV_REASON_POP', //* 성공/부진사유/대책 미리보기팝업 ON/OFF 설정
  GET_VIEWS_MANAGER_POP: 'GET_VIEWS_MANAGER_POP', //* 담당자검색 팝업 ON/OFF 설정
  GET_KPI_PERFORM_LIST: 'GET_KPI_PERFORM_LIST', //*KPI실적 리스트 조회
  GET_KPI_PERFORM_REPORT_LIST: 'GET_KPI_PERFORM_REPORT_LIST', //*KPI실적 리스트 조회(보고용)
  GET_KPI_REASON_MEASURE_LIST: 'GET_KPI_REASON_MEASURE_LIST', //* KPI성공/부진사유 대책 리스트 조회
  GET_KPI_REASON_MEASURE_REPORT_LIST: 'GET_KPI_REASON_MEASURE_REPORT_LIST', //* KPI성공/부진사유 대책 리스트 조회(보고용)
  GET_DATA_SEARCH_KPI_DATA: 'GET_DATA_SEARCH_KPI_DATA', //* 검색, 열람 용 데이터
  GET_SELECTED_KPI_DATA: 'GET_SELECTED_KPI_DATA', //* 선택한 kpi정보
  GET_KPI_PRJ_LIST: 'GET_KPI_PRJ_LIST', //* 연결과제 리스트 조회
  GET_SELECTED_ANALY_KPI_INFO_DATA: 'GET_SELECTED_ANALY_KPI_INFO_DATA', //*선택한 kpi정보 가져오기
  GET_PERFORM_SEARCH_USER_ID: 'GET_PERFORM_SEARCH_USER_ID', //*실적리스트 검색한 사용자 ID
  GET_KPI_LATEST_RESULT: 'GET_KPI_LATEST_RESULT', //* KPI 최근/누적실적 가져오기
};

export const actions = {
  // TODO: FETCH CONSTANT DECLARATION
  FETCH_KPI_PERFORM_LIST: 'FETCH_KPI_PERFORM_LIST', //* KPI실적 리스트 조회
  FETCH_KPI_PERFORM_REPORT_LIST: 'FETCH_KPI_PERFORM_REPORT_LIST', //* KPI실적 리스트 조회(보고용)
  FETCH_KPI_REASON_MEASURE_LIST: 'FETCH_KPI_REASON_MEASURE_LIST', //* KPI성공/부진사유 대책 리스트 조회
  FETCH_KPI_REASON_MEASURE_REPORT_LIST: 'FETCH_KPI_REASON_MEASURE_REPORT_LIST', //* KPI성공/부진사유 대책 리스트 조회(보고용)
  FETCH_KPI_PRJ_LIST: 'FETCH_KPI_PRJ_LIST', //* 연결과제 리스트 조회
  FETCH_KPI_TARGET_MONTH_LIST: 'FETCH_KPI_TARGET_MONTH_LIST', //* 월목표실적 데이터 가져오기
  FETCH_ENTIRE_WEEK: 'FETCH_ENTIRE_WEEK', //* 전체 주 목록 가져오기
  FETCH_KPI_LATEST_RESULT: 'FETCH_KPI_LATEST_RESULT', //* KPI 최근/누적실적 가져오기

  // TODO: UPDATE CONSTANT DECLARATION
  UPDATE_TAB_LIST: 'UPDATE_TAB_LIST', //* 탭 추가 하기
  UPDATE_KPI_PERFORM_SINGLE: 'UPDATE_KPI_PERFORM_SINGLE', //* 실적리스트 단일ROW 업데이트
  UPDATAE_KPI_REASON_DATA: 'UPDATAE_KPI_REASON_DATA', //* 성공부진사유 저장
  UPDATAE_KPI_MEASURE_DATA: 'UPDATAE_KPI_MEASURE_DATA', //* 성공부진사유 대책 저장
  UPDATE_KPI_PERFORM_MW: 'UPDATE_KPI_PERFORM_MW', //* 월별 KPI 주간 실적 저장
  UPDATE_KPI_PRJ_LIST: 'UPDATE_KPI_PRJ_LIST', //*과제연결
  UPDATE_KPI_PERFORM_MONTH_DATA: 'UPDATE_KPI_PERFORM_MONTH_DATA', //*월실적 업데이트
  UPDATE_KPI_PERFORM_WEEK_DATA: 'UPDATE_KPI_PERFORM_WEEK_DATA', //*주실적 업데이트
  // TODO: DELETE CONSTANT DECLARATION
  DELETE_KPI_REASON_DATA: 'DELETE_KPI_REASON_DATA', //* 성공부진사유 삭제
  DELETE_KPI_MEASURE_DATA: 'DELETE_KPI_MEASURE_DATA', //* 성공부진사유 대책 삭제
  DELETE_KPI_PRJ_DATA: 'DELETE_KPI_PRJ_DATA', //*연결과제 삭제
  // TODO: INIT CONSTANT DECLARATION
  INIT_KPI_REASON_MEASURE_LIST: 'INIT_KPI_REASON_MEASURE_LIST', //*KPI성공/부진사유 대책 리스트 세팅
  INIT_KPI_REASON_MEASURE_REPORT_LIST: 'INIT_KPI_REASON_MEASURE_REPORT_LIST', //*KPI성공/부진사유 대책 리스트 세팅(보고용)
  INIT_SELECTED_KPI_DATA: 'INIT_SELECTED_KPI_DATA', //* 선택한 kpi정보 세팅
  INIT_KPI_TARGET_MONTH_LIST: 'INIT_KPI_TARGET_MONTH_LIST', //* 월목표실적 데이터 세팅
  INIT_SELECTED_ANALY_KPI_INFO_DATA: 'INIT_SELECTED_ANALY_KPI_INFO_DATA', //*선택한 kpi정보 세팅
  INIT_PERFORM_SEARCH_USER_ID: 'INIT_PERFORM_SEARCH_USER_ID', //*실적리스트 검색한 사용자 ID
  INIT_KPI_PERFORM_LIST: 'INIT_KPI_PERFORM_LIST', //*실적리스트 세팅
  INIT_DATA_SEARCH_KPI_DATA: 'INIT_DATA_SEARCH_KPI_DATA', //* 검색, 열람 용 데이터
  INIT_WWSEQ_PARAM: 'INIT_WWSEQ_PARAM', //* 주차 파마리터 전달
  //! 탭 컨텐츠 ON/OFF 설정
  INIT_VIEWS_KPI_PERFORM_LIST: 'INIT_VIEWS_KPI_PERFORM_LIST', //* 실적리스트 영역 ON/OFF 설정
  INIT_VIEWS_KPI_REASON_LIST: 'INIT_VIEWS_KPI_REASON_LIST', //* 성공부진사유 리스트 영역 ON/OFF 설정
  //! 팝업 ON/OFF 설정
  INIT_VIEWS_KPI_REG_PERFORM_POP: 'INIT_VIEWS_KPI_REG_PERFORM_POP', //* 실적입력 팝업 ON/OFF 설정
  INIT_VIEWS_KPI_PRJ_POP: 'INIT_VIEWS_KPI_PRJ_POP', //* 연결과제 팝업 ON/OFF 설정
  INIT_VIEWS_CHART_GROUP_POP: 'INIT_VIEWS_CHART_GROUP_POP', //* 차트그룹 리스트팝업 ON/OFF 설정
  INIT_VIEWS_SELECTED_CHART_GROUP_POP: 'INIT_VIEWS_SELECTED_CHART_GROUP_POP', //* 선택된 차트그룹 팝업 ON/OFF 설정
  INIT_VIEWS_ANALYSIS_POP: 'INIT_VIEWS_ANALYSIS_POP', //* 분석 팝업 ON/OFF 설정
  INIT_VIEWS_PREV_REASON_POP: 'INIT_VIEWS_PREV_REASON_POP', //* 성공/부진사유/대책 미리보기팝업 ON/OFF 설정
  INIT_VIEWS_MANAGER_POP: 'INIT_VIEWS_MANAGER_POP', //* 담당자검색 팝업 ON/OFF 설정
};

export const mutations = {
  SET_TAB_LIST: 'SET_TAB_LIST', //* 탭 추가 하기
  SET_KPI_PERFORM_LIST: 'SET_KPI_PERFORM_LIST', //*KPI실적 리스트 세팅
  SET_KPI_PERFORM_REPORT_LIST: 'SET_KPI_PERFORM_REPORT_LIST', //*KPI실적 리스트 세팅(보고용)
  SET_KPI_REASON_MEASURE_LIST: 'SET_KPI_REASON_MEASURE_LIST', //* KPI성공/부진사유 대책 리스트 세팅
  SET_KPI_REASON_MEASURE_REPORT_LIST: 'SET_KPI_REASON_MEASURE_REPORT_LIST', //* KPI성공/부진사유 대책 리스트 세팅(보고용)
  SET_SELECTED_KPI_DATA: 'SET_SELECTED_KPI_DATA', //* 선택한 kpi정보 세팅
  SET_KPI_PRJ_LIST: 'GET_KPI_PRJ_LIST', //* 연결과제 리스트 세팅
  SET_KPI_TARGET_MONTH_LIST: 'SET_KPI_TARGET_MONTH_LIST', //* 월목표실적 데이터 가져오기
  SET_SELECTED_ANALY_KPI_INFO_DATA: 'SET_SELECTED_ANALY_KPI_INFO_DATA', //*선택한 kpi정보 세팅
  SET_SAVED_REASON_ID: 'SET_SAVED_REASON_ID', //*저장한 성공/부진사유 정보
  SET_SAVED_MEASURE_ID: 'SET_SAVED_MEASURE_ID', //*저장한 성공/부진사유 대책 정보
  SET_PERFORM_SEARCH_USER_ID: 'SET_PERFORM_SEARCH_USER_ID', //*실적리스트 검색한 사용자 ID
  SET_DATA_SEARCH_KPI_DATA: 'SET_DATA_SEARCH_KPI_DATA', //* 검색, 열람 용 데이터
  SET_ENTIRE_WEEK: 'SET_ENTIRE_WEEK', //* 전체 주 목록 가져오기
  SET_WWSEQ_PARAM: 'SET_WWSEQ_PARAM', //* 주차 파마리터 전달
  //! 탭 컨텐츠 ON/OFF 설정
  SET_VIEWS_KPI_PERFORM_LIST: 'SET_VIEWS_KPI_PERFORM_LIST', //* 실적리스트 영역 ON/OFF 설정
  SET_VIEWS_KPI_REASON_LIST: 'SET_VIEWS_KPI_REASON_LIST', //* 성공부진사유 리스트 영역 ON/OFF 설정
  //! 팝업 ON/OFF 설정
  SET_VIEWS_KPI_REG_PERFORM_POP: 'SET_VIEWS_KPI_REG_PERFORM_POP', //* 실적입력 팝업 ON/OFF 설정
  SET_VIEWS_KPI_PRJ_POP: 'SET_VIEWS_KPI_PRJ_POP', //* 연결과제 팝업 ON/OFF 설정
  SET_VIEWS_CHART_GROUP_POP: 'SET_VIEWS_CHART_GROUP_POP', //* 차트그룹 리스트팝업 ON/OFF 설정
  SET_VIEWS_SELECTED_CHART_GROUP_POP: 'SET_VIEWS_SELECTED_CHART_GROUP_POP', //* 선택된 차트그룹 팝업 ON/OFF 설정
  SET_VIEWS_ANALYSIS_POP: 'SET_VIEWS_ANALYSIS_POP', //* 분석 팝업 ON/OFF 설정
  SET_VIEWS_PREV_REASON_POP: 'SET_VIEWS_PREV_REASON_POP', //* 성공/부진사유/대책 미리보기팝업 ON/OFF 설정
  SET_VIEWS_MANAGER_POP: 'SET_VIEWS_MANAGER_POP', //* 담당자검색 팝업 ON/OFF 설정
  SET_KPI_LATEST_RESULT: 'SET_KPI_LATEST_RESULT', //* KPI 최근/누적실적 설정
};

//* ROOT ACTIONS CONSTANT
export const rootActions = {
  ...Object.entries(actions).reduce((acc, cur) => {
    acc[cur[0]] = `kpiPerformance/${cur[1]}`;
    return acc;
  }, {}),
};

//* ROOT MUTATIONS CONSTANT
export const rootMutations = {
  ...Object.entries(mutations).reduce((acc, cur) => {
    acc[cur[0]] = `kpiPerformance/${cur[1]}`;
    return acc;
  }, {}),
};
